import ListItemButton from '@mui/material/ListItemButton';
import { Grid, Box, CircularProgress } from '@mui/material';

export default function ScanSkeleton() {
    const styles = {
        scanPlaceholder: {
            height: {
                xs: '100px',
                sm: '190px',
            },
            mb: 2,
            borderRadius: '12px',
            backgroundColor: '#E6E6E7',
        }
    }
    return (
        <ListItemButton sx={styles.scanPlaceholder}>
            <Grid container direction="column">
                <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
                    <CircularProgress size={60} />
                </Box>
            </Grid>
        </ListItemButton>
    );
}